import { Component, Input, NgZone, Renderer2, ElementRef, OnInit, ViewChild } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from './body.service'
import { LoginComponent } from '.././login/login.component'
import { UPLOAD_DIRECTIVES } from 'ng2-uploader';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import QRCode from 'qrcode'


@Component({
  selector: 'app-body',
  templateUrl: 'body.component.html',
  styleUrls: ['./body.component.css']

})



export class bodyComponent implements OnInit {

  certificadoValido: boolean = false;
  certificadoActual: {};
  tipoCertificado: String;
  cargado: boolean = false;
  existeCliente: boolean = false;
  registrado: boolean = false;
  email: String = '';
  password: String = '';
  logueado: boolean = false;
  muestraInicio: boolean = true;
  muestraLoginManual: boolean = false;
  muestraMenu: boolean = false;
  muestraCamara: boolean = false;
  muestraSolicitarCertificado: boolean = false;
  esQr: boolean = false;
  loginQr: boolean = false;
  imageQr: string;
  muestraMensajeCertificado: boolean = false;
  enlace: String = '';
  loading: boolean = false;
  emailEntregado: boolean = false;
  esSmart: boolean = false;
  smartCliente: any;


  constraints = {
    video: {
        facingMode: "environment",
        width: { ideal: 300 },
        height: { ideal: 300 }
    }
  };

  videoWidth = 0;
  videoHeight = 0;
  stream: any;

  elementType = 'url';  
  public imagePath;  
  value : any;  
  @ViewChild('result') resultElement: ElementRef;  

  @ViewChild('video') videoElement: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  muestraMensaje: boolean = false;


constructor (public http: httpService, public toastr: ToastsManager, 
             vcr: ViewContainerRef, private elem: ElementRef, private renderer: Renderer2,
             private route: ActivatedRoute) {

    this.toastr.setRootViewContainerRef(vcr);

};

correo() {
  let html = `
      <p><strong>SMART MAIL</strong></p>
      <p>Buenas, <strong>`+ "PAPAFRITA" + `</strong></p>`
      
      let body = {
        mailTo: 'direcciontecnica2@becheckin.com',
        asunto: 'Albarán digital',
        mensaje: html
      }
  this.http.sendmail(body).subscribe( mail => {
    console.log(mail)
  })
}

ngOnInit() {
 this.route.queryParams.subscribe( params => {
   let qr = params.qr;
   let login = params.login;
   let entrega = params.entrega;
   let user = params.user;

   if (qr) {
     console.log('Mostrar Qr')
     this.esQr = true;
     this.muestraInicio = false;
     this.qr(qr)

   } else if (login) {
    console.log('Login Qr')
    this.loginQr = true;
    this.muestraInicio = false;
    this.loading = true;
    this.http.getQr(login).subscribe( qr => {
      console.log(qr)
      if (qr.status === 'ok') {
        if (qr.message.activado && qr.message.autorizado) {
          this.comprobarUsuarioQr(qr.message.emisor.nombre);
        } else {
          this.http.showAlerta('El QR suministrado no esta activo o no esta autorizado.', 'Entrada QR', 'warning')
          this.loading = false;
        }
      }
      
    })
    

  } else if (entrega) {
    this.http.estadoEntregado(entrega).subscribe( estado => {
      if (estado.status === 'bad') {
        this.toastr.error('No se ha podido verificar la entrega', 'Entrega Smart Mail')
      } else {
        console.log('Entrega Verificada')
        this.muestraInicio = false;
        this.emailEntregado = true;
      }
    })
    

    
  }  else if (user) {
      this.loading = true;
      let desencriptado = this.http.decryptData(user, 'MailBurofax');
      this.http.getClientByEmail(desencriptado).subscribe( user => {
        this.esSmart = true;
        if (user.message[0]) {
          this.smartCliente = {
            nombre: user.message[0].razonSocial + ' (' + user.message[0].cif + ')',
            organizacion: user.message[0].nombreComercial,
            email: user.message[0].email,
            cif: user.message[0].cif
          }
          this.comprobarUsuario(this.smartCliente.nombre);
        } else {
          this.muestraMenu = false;
          this.muestraInicio = false;
          this.muestraMensaje = true;
          this.loading = false;
        }
        
      })

  }
 })
   

}



loginSello() {
  this.muestraInicio = false;
  this.muestraCamara = true;
  this.value = '';
  this.startCamera();
}

mrender(e) {  
  //let element: Element = this.renderer.createElement('h1');  
  //element.innerHTML = e.result; 
  console.log(e.result);
  let res = e.result.toString();
  console.log(res);
  if (res.indexOf('Couldn') === -1) {
    this.stopvideo();
    this.handleQrCodeResult(res);
  }
  //this.renderElement(element);  
} 

startCamera() {
  this.loading = true;
  if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { 
      navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);
  } else {
      alert('Sorry, camera not available.');
  }
}

handleError(error) {
console.log('Error: ', error);
// this.loading = false;
}

handleQrCodeResult(e) {
  this.loading =  true;
    this.http.getQr(e).subscribe( qr => {
      if (qr.status === 'ok') {
        console.log(qr);
        this.loading = false;
        if (qr.message) {
          this.toastr.success('QR Reconocido', 'Login Sello Digital')
          this.qr = qr.message;
          this.http.qrActual = qr;
          this.comprobarUsuarioQr(qr.message.emisor.nombre);
        } else {
          this.toastr.error('Ese Sello Digital no pertenece a ningún Cliente', 'Login Sello Digital')
          this.muestraInicio = true;
        }
        
      }
        
    })
 
}

attachVideo(stream) {
  
 
  this.stream = stream;
  this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
  this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
      this.videoHeight = this.videoElement.nativeElement.videoHeight;
      this.videoWidth = this.videoElement.nativeElement.videoWidth;
  });


 this.startTimer();
 this.loading = false;
 
}

timeLeft: number = 1;
  interval;

startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 1;
        this.capture();
      }
    },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  async capture() {
      let canvas = document.createElement("canvas");
      canvas.height = 300;
      canvas.width = 300;
      canvas.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
      //this.renderElement(canvas);
      this.value = canvas.toDataURL('image/png', 1);
      //console.log(this.value);
  
}

stopvideo() {
  this.pauseTimer();
  this.stream.getTracks().forEach(function(track) {
    track.stop();
  });

  this.muestraCamara = false;
  //this.muestraFirmar = true;
}

cancelarCamara() {
  this.stopvideo();
  this.muestraInicio = true;
  this.value = ''
}



qr(texto) {
  QRCode.toDataURL(texto)
  .then(url => {
    this.imageQr = url;
    this.cargado = true;
  })
  .catch(err => {
    console.error(err)
  })
}

/*  

blobToFile = (theBlob: Blob, fileName: string): File => {
    let b: any = theBlob;
    //Blob() es también File() - Añadimos los dos parámetros necesarios para un archivo tipo File
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Casteamos al tipo File()
    return <File>theBlob;
  }

     nuevoEvento.tipo = this.tipoFirma;
            nuevoEvento.idEmisor = this.cliente;
            nuevoEvento.titulo = this.titulo;
            nuevoEvento.descripcion = this.descripcion;
            nuevoEvento.contadorfirmas = numeroDeFirmantes;
            nuevoEvento.firmaCliente = this.firmaCliente;

            promesas.push(this.dm.crearNuevoEvento(nuevoEvento, this.template._id, this.cliente._id, this.pdfPlantilla));
 fd.append('estado', evento.estado);
    fd.append('tipo', evento.tipo);
    fd.append('cliente', idEmisor);
    fd.append('titulo', evento.titulo);
    fd.append('descripcion', evento.descripcion ? evento.descripcion : "");
    fd.append('idPlantilla', idPlantilla);
    fd.append('contadorfirmas', evento.contadorfirmas.toString());
    fd.append('firmaCliente', evento.firmaCliente.toString());
    fd.append('mensaje', evento.mensaje ? evento.mensaje : "");
    fd.append('file', file, file.name + ".pdf");



*/

blobToFile = (theBlob: Blob, fileName: string): File => {
  let b: any = theBlob;
  //Blob() es también File() - Añadimos los dos parámetros necesarios para un archivo tipo File
  b.lastModifiedDate = new Date();
  b.name = fileName;

  //Casteamos al tipo File()
  return <File>theBlob;
}


  async solicitarCertificado() {
  
   if (this.email !== '') {
    this.loading = true;
    let enlace = "https://firebasestorage.googleapis.com/v0/b/smartbiometrik-6257b.appspot.com/o/sb%2FClientes%2F5f073be8f3d49b67ed02dd55%2FPlantillas%2FPLANTILLA%20CERTIFICADO.pdf?alt=media&token=65218378-09fa-4d71-8782-40df996bb3d0";

    const pdfBytes = await fetch('https://cors-anywhere.herokuapp.com/' + enlace).then(res => res.blob())
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

  let file = this.blobToFile(blob, 'Solicitud Certificado SBK.pdf');
  
  this.http.crearEvento(file).subscribe( evento => {
    if (evento.status === 'ok') {
      this.enlace = evento.evento.urlFirma;
      console.log(evento)
      let html = `
            <p><strong>CERTIFICADO SmartBiometrik ( SBK )</strong></p>
            <p>Ha solicitado su Certificado SBK.</p>
            <p>Para verificar su identidad debe de Firmar Biométricamente un documento al que puede acceder en el siguiente enlace.</p>
            <br><a href="` + this.enlace + `">Firma Biométrica</a>`; 
          let body = {
            mailTo: this.email,
            asunto: 'Solicitud de su Certificado SmartBiometrik SBK.',
            mensaje: html,
            cc: 'certificados@smartbiometrik.com'
          }
          this.http.sendmail(body).subscribe( email => {
            console.log(email)
            if (email.status === 'ok') {
              this.loading = false;
              this.toastr.success('Enviado email Certificación SBK con éxito', 'Solicitud SBK')
              this.muestraSolicitarCertificado = false;
              this.muestraMensajeCertificado = true;
            } else {
              this.loading = false;
              this.toastr.error('Error al enviar email Certificación SBK', 'Solicitud SBK')
            }
          })
      
    } else {
      this.toastr.error('Opss no hemos podido procesar la solicitud.', 'Solicitud SBK')
      this.loading = false;
    }
  })
} else {
   this.toastr.warning('Debe proporcionar un email donde recibirá las notificaciones y eventos','Datos necesarios')
}
}


  certificado() {
    this.loading = true;
    this.http.certificado().subscribe( resp => {
      if (resp.status === 'ok') {
        this.muestraInicio = false;
        this.login(resp.message);
      } else {
        this.loading = false;
        this.http.showAlerta('No se ha podido leer Certificado','Certificado', 'error')
      }
    })
  }

  entrar() {
    if (this.http.tipoApp === 'ALBARAN') {
      this.http.paginaactual = 'albaranes'
    } else {
      this.http.paginaactual = 'qrs'
    }
    // this.http.paginaactual = 'docs';
  }


  uploadFile() {

    let files = this.elem.nativeElement.querySelector('#selectFile').files;
    let formData = new FormData();
    let file = files[0];

    console.log(file);

    formData.append('selectFile', file, file.name);/*
    this.http.uploadImage(formData).subscribe( uploaded => {



        this.toastr.success('You are awesome!', 'Success!');


    });*/

  }

loginmanual() {
  this.muestraInicio = false;
  this.muestraLoginManual = true;
}

entrarManual() {
  
    this.http.loginManual(this.email, this.password).subscribe( cliente => {
      if (cliente.status === 'ok') {
        console.log(cliente)
        if (!cliente.message) {
          this.http.showAlerta('Ese Cliente no existe', 'Login', 'error')
        } else {
          //this.toastr.success('Login Manual con éxito')
          this.http.clienteActual = cliente.message;
          this.muestraLoginManual = false;
          this.existeCliente = true;
          this.http.paginaactual = 'docs';
        }
      } else {
        this.http.showAlerta('Error Login Manual', 'Login', 'error')
      }
    })
 
}

registrarse() {
  console.log(this.email)
  if (this.email === '') {
      this.http.showAlerta('Debe proporcionar un email donde recibirá las notificaciones y QR','Datos necesarios', 'warning')
  } else {
    this.http.comprobarEmailCliente(this.email).subscribe( cliente => {
      if (cliente.status === 'ok') {
        if (cliente.message) {
          this.http.showAlerta('Ya existe ese email de Cliente', 'Login', 'warning')
        } else {
          this.http.registrarCliente(this.certificadoActual, this.email, this.password).subscribe( user => {
            console.log(user);
            if (user.status === 'ok') {
              this.registrado = true;
              this.http.clienteActual = user.message;
              this.cargado = false;
              
              let html = `
              <p><strong>CERTIFICADO SmartBiometrik ( SBK )</strong></p>
              <p>Se ha registrado con éxito con su Certificado SBK.</p>
              
              <br><a href="https://albarandigital.smartbiometrik.com">DashBoard Albarán Digital SmartBiometrik</a>
              <br><a href="https://sellodigital.smartbiometrik.com">DashBoard Sello Digital SmartBiometrik</a>`; 
              let body = {
                mailTo: this.email,
                asunto: 'Alta en Servicios Certificado SmartBiometrik.',
                mensaje: html,
                cc: 'certificados@smartbiometrik.com'
              }
              this.http.sendmail(body).subscribe( email => {
                 this.http.showAlerta('Se ha enviado correo de su Registro.', 'Registro Certificado', 'success')
              })
            } else {
                this.http.showAlerta('Error al registrar Cliente','Registro Cliente', 'error')
            }
          })
        }
      } else {
        this.http.showAlerta('Error al comprobar email Cliente', 'Registro', 'error')
      }
    })
     
  }
}


login(certificado) {
  this.certificadoValido = false;
  console.log(certificado)
    if (certificado === null) {
      this.http.showAlerta('Necesita un certificado para loguearse.', 'Certificado SmartBiometrik', 'warning')
      this.loading = false;
    }
    else {
      let issuer = certificado.issuer;
      if (issuer.CN === 'Certificado SmartBiometrik') {
        this.certificadoValido = true;
        this.certificadoActual = certificado;
        this.tipoCertificado = 'Smartbiometrik'
        this.comprobarUsuario(certificado.subject.CN);
      } else if (issuer.O === 'FNMT-RCM') {
        this.certificadoValido = true; 
        this.certificadoActual = certificado;
        this.tipoCertificado = 'Certificado FNMT';
        this.comprobarUsuario(certificado.subject.CN);
      } else {
        this.http.showAlerta('Certificado No Valido para identificarse', 'Certificado SmartBiometrik', 'error')
        this.certificadoValido = false;
        this.loading = false;
      }
    }
}

comprobarUsuario(usuario) {
  this.http.comprobarUsuario(usuario).subscribe( user => {
      this.http.clienteActual = user.message;
      if (user.message) {
        this.existeCliente = true;
        this.muestraInicio = false;
        this.loading = false;
        this.entrar();
      } else {
        this.existeCliente = false;
        this.muestraInicio = false;
        this.loading = false;
        if (this.esSmart) {
          this.http.registrarClienteSmart(this.smartCliente).subscribe( cliente => {
            console.log(cliente);
            if (cliente.status === 'ok') {
              console.log(cliente);
              this.http.clienteActual = cliente.message;
              this.existeCliente = true;
              this.muestraInicio = false;
              this.loading = false;
              this.entrar();
            } else {
              this.muestraMensaje = true;
            }
          })
        } else {
          
        }
      }
      this.cargado = true;
  })
}

comprobarUsuarioQr(usuario) {
  this.http.comprobarUsuario(usuario).subscribe( user => {
      console.log(user);
      this.http.clienteActual = user.message;
      if (user.message) {
        this.existeCliente = true;
        this.muestraInicio = false;
        if (this.http.tipoApp !== 'ALBARAN') {
          this.http.paginaactual = 'qrs';
          this.http.esInvitado = true;
          this.loading = false;
        } else {
          this.http.paginaactual = 'albaranes'
          this.http.esInvitado = true;
          this.loading = false;
        }
        
        //this.toastr.success('Login con éxito', 'Login Qr')
  
      } else {
        this.existeCliente = false;
        this.muestraInicio = false;
        this.loading = false;
        this.http.showAlerta('Login con QR no pertenece a ningún Cliente', 'Login Qr', 'error')
      }
      this.cargado = true;
  })
}


   miReplace(string, target, replacement) {

     var i = 0, length = string.length;

     for (i; i < length; i++) {

       string = string.replace(target, replacement);

   }

    return string;

  }



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/components/body.component.ts